import { useState } from "react";
import Autocomplete from "../../library/Autocomplete";
import TAGS from "../../clinks/tags/Tags";

interface TagsAutocompleteProps {
  onChange: (e: React.SyntheticEvent) => void;
  onBlur?: (e: React.SyntheticEvent) => void;
  onKeyDown?: (e: React.SyntheticEvent) => void;
  options: string[];
  selected: string[];
  reactRef: React.RefObject<HTMLElement> | ((e: React.SyntheticEvent) => void);
  style?: {[key:string]:string};
}

function TagsAutocomplete(props: TagsAutocompleteProps) {
  const options = new Set([...props.options, ...TAGS]);
  const renderNewTagSelectionElement = (searchTag:string) => {
    return (
      <span>
        New tag: {searchTag}
      </span>
    );
  }
  const [newSelectionPrefix, setNewSelectionPrefix] = useState(
    renderNewTagSelectionElement("")
  );

  const onInputChange = (searchString:any) => {
    setNewSelectionPrefix(renderNewTagSelectionElement(searchString));
  }

  return <Autocomplete 
            id="tagsAutocomplete"
            placeholder="Tags" 
            reactKey="tagsAutocomplete"
            allowNew
            newSelectionPrefix={newSelectionPrefix}
            onInputChange={onInputChange}
            onChange={props.onChange} 
            onBlur={props.onBlur}
            style={props.style}
            options={Array.from(options)}
            selected={props.selected}
            paginate={false} 
            reactRef={props.reactRef}
            onKeyDown={props.onKeyDown}
            multiple
          />;
}

export default TagsAutocomplete;
